import { Icon, LoadingBlock } from '@/design'

import { useMarketQuery } from './hooks'

/**
 * There is no scraping or monitoring code in this release. The `monitor`
 * observation source exists in the model for later; this is where a viewer
 * finds out it is not switched on, and why.
 */
export function MonitoringNotice() {
  const status = useMarketQuery('monitoring-status', (client) => client.marketMonitoringStatus())

  if (status.isPending) return <LoadingBlock rows={1} />
  if (!status.data) return null

  return (
    <p className="mk-monitoring" role="note">
      <Icon name="lock" size={14} />
      <span>
        <strong>Monitoring: not enabled.</strong> {status.data.data.note}
      </span>
    </p>
  )
}
